import { render, staticRenderFns } from "./push.vue?vue&type=template&id=7f2dd062&scoped=true&"
import script from "./push.vue?vue&type=script&lang=ts&"
export * from "./push.vue?vue&type=script&lang=ts&"
import style0 from "./push.vue?vue&type=style&index=0&id=7f2dd062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2dd062",
  null
  
)

export default component.exports